import store from '@/store/index'

const steps = [{ path: '', name: 'webapp', redirect: { name: 'OrderType' } }]
store.getters.routesWizard.map((item) => {
  steps.push({
    path: item.path,
    name: item.component,
    component: () => import(`@/views/steps/${item.component}.vue`),
    meta: {
      title: `browserTitle.${item.component}`
    },
    beforeEnter (to, from, next) {
      store.getters.tabbarError.status = false
      Object.keys(store.getters.showFeedbacks).forEach((index) => {
        store.getters.showFeedbacks[index] = false
      })

      if (!item.permission) {
        next({ name: 'default' })
        return
      }

      next()
    }
  })
})

export default steps
